var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "mobile-download" }, [
      _c("div", { staticClass: "logo" }, [
        _c(
          "svg",
          {
            staticClass: "icon",
            attrs: { slot: "image", "aria-hidden": "true" },
            slot: "image"
          },
          [_c("use", { attrs: { "xlink:href": "#icon-daiwenzilogo" } })]
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "title" }, [_vm._v("Download SUPEREX")]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "fotterBotton" },
          [
            _vm.isIOS
              ? _c(
                  "van-button",
                  {
                    staticClass: "button",
                    attrs: { type: "default", disabled: !_vm.appStoreUrl },
                    on: {
                      click: function($event) {
                        return _vm.handleClick(_vm.appStoreUrl)
                      }
                    }
                  },
                  [
                    _c("div", { attrs: { slot: "icon" }, slot: "icon" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "icon",
                          attrs: { slot: "image", "aria-hidden": "true" },
                          slot: "image"
                        },
                        [_c("use", { attrs: { "xlink:href": "#icon-ios1" } })]
                      )
                    ]),
                    _vm._v("\n          App Store "),
                    _c(
                      "em",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.appStoreUrl,
                            expression: "!appStoreUrl"
                          }
                        ]
                      },
                      [_vm._v("(Reviewing)")]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isIOS
              ? _c(
                  "van-button",
                  {
                    staticClass: "button",
                    attrs: { type: "default", disabled: !_vm.TFLink },
                    on: {
                      click: function($event) {
                        return _vm.handleClick(_vm.TFLink)
                      }
                    }
                  },
                  [
                    _c("div", { attrs: { slot: "icon" }, slot: "icon" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "icon",
                          attrs: { slot: "image", "aria-hidden": "true" },
                          slot: "image"
                        },
                        [_c("use", { attrs: { "xlink:href": "#icon-ios1" } })]
                      )
                    ]),
                    _vm._v("\n          TestFlight "),
                    _c(
                      "em",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.TFLink,
                            expression: "!TFLink"
                          }
                        ]
                      },
                      [_vm._v("(Reviewing)")]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isIOS
              ? _c(
                  "van-button",
                  {
                    staticClass: "button",
                    attrs: { type: "default", disabled: !_vm.androidApk },
                    on: {
                      click: function($event) {
                        return _vm.handleClick(_vm.androidApk)
                      }
                    }
                  },
                  [
                    _c("div", { attrs: { slot: "icon" }, slot: "icon" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "icon",
                          attrs: { slot: "image", "aria-hidden": "true" },
                          slot: "image"
                        },
                        [
                          _c("use", {
                            attrs: { "xlink:href": "#icon-anzhuo3" }
                          })
                        ]
                      )
                    ]),
                    _vm._v("\n          Android APK "),
                    _c(
                      "em",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.androidApk,
                            expression: "!androidApk"
                          }
                        ]
                      },
                      [_vm._v("(Reviewing)")]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isIOS
              ? _c(
                  "van-button",
                  {
                    staticClass: "button",
                    attrs: { type: "default", disabled: !_vm.googlePlayUrl },
                    on: {
                      click: function($event) {
                        return _vm.handleClick(_vm.googlePlayUrl)
                      }
                    }
                  },
                  [
                    _c("div", { attrs: { slot: "icon" }, slot: "icon" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "icon",
                          attrs: { slot: "image", "aria-hidden": "true" },
                          slot: "image"
                        },
                        [_c("use", { attrs: { "xlink:href": "#icon-guge2" } })]
                      )
                    ]),
                    _vm._v("\n          Google Play "),
                    _c(
                      "em",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.googlePlayUrl,
                            expression: "!googlePlayUrl"
                          }
                        ]
                      },
                      [_vm._v("(Reviewing)")]
                    )
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "title google-title" }, [
          _vm._v("Google/Microsoft Auth")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "title-tip" }, [
          _vm._v(
            "\n        Google/Microsoft authenticator generates 2-Step verification codes.\n        Increase your account safety by downloading the SuperEx authenticator\n        for a second step of verification.\n      "
          )
        ]),
        _vm._v(" "),
        _vm.isIOS
          ? _c(
              "a",
              {
                staticClass: "link",
                attrs: {
                  href:
                    "https://apps.apple.com/us/app/google-authenticator/id388497605",
                  target: "_blank"
                }
              },
              [_vm._v("Download Google Auth")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isIOS
          ? _c(
              "a",
              {
                staticClass: "link",
                attrs: {
                  href:
                    "https://apps.apple.com/us/app/microsoft-authenticator/id983156458",
                  target: "_blank"
                }
              },
              [_vm._v("Download Microsoft Auth")]
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.isIOS
          ? _c(
              "a",
              {
                staticClass: "link",
                attrs: {
                  href:
                    "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2",
                  target: "_blank"
                }
              },
              [_vm._v("Download Google Auth")]
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.isIOS
          ? _c(
              "a",
              {
                staticClass: "link",
                attrs: {
                  href:
                    "https://play.google.com/store/apps/details?id=com.azure.authenticator",
                  target: "_blank"
                }
              },
              [_vm._v("Download Microsoft Auth")]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "slogan" }, [
        _vm._v(
          "\n      Every trade you make is fuel for humans to fly into space\n    "
        )
      ])
    ]),
    _vm._v(" "),
    _vm.isWecth
      ? _c("div", { staticClass: "isWecth" }, [
          _c("div", { staticClass: "jiantouImg" }, [
            _c(
              "svg",
              {
                staticClass: "icon",
                attrs: { slot: "image", "aria-hidden": "true" },
                slot: "image"
              },
              [_c("use", { attrs: { "xlink:href": "#icon-xiazaiyindao" } })]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "wenzi" }, [
            _vm._v("Please click [...] to open it in the browser")
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-tip" }, [
      _c("p", [_vm._v("The Super Exchange app")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n          SuperEx's mission is to create a regulated and open financial\n          platform for the world by leveraging blockchain technology.\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n          Our main services include cryptocurrency trading, derivatives\n          trading and high-security storage. While also supporting more\n          innovative services, such as DEFI, NFT, financial management,\n          mining, stocks, etc.\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n          Everyone in the world deserves a safe, easy-to-use way to access\n          digital currency markets.\n        "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-af7446ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af7446ae","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/download.vue
// module id = LG2K
// module chunks = 0